import React, { useEffect } from "react";
import Styles from "./CardList.module.scss";
import { useAppDispatch } from "../../redux/store";
import cardIcon from "../../assets/icons/card.svg";

import { CardListPropsType } from "./types";
import { setCardid, setShouldSaveCard } from "../../redux/profile/cards/slice";

/**
 * Способ оплаты.
 *
 * ЮKassa убрана с сайта, вместе с ней ушла и привязка карт: у неё это был
 * токен карты, а у Т-Кассы механизм другой (CustomerKey + Recurrent + Rebill)
 * и он пока не реализован. Поэтому:
 *   - на странице оплаты остаётся один способ — оплата картой на форме Т-Кассы;
 *   - в профиле список карт и кнопка привязки скрыты: показывать карты, которыми
 *     нельзя заплатить, — врать пользователю.
 *
 * Когда появится Rebill, сюда возвращается список карт и кнопка привязки через
 * AddCard/AttachCard.
 */
export const CardList: React.FC<CardListPropsType> = (props) => {
  const { onPage = "profile", onClickFunc } = props;
  const dispatch = useAppDispatch();

  // Способ один — выбираем его сразу, иначе кнопка «Оплатить» висит
  // заблокированной в ожидании клика по единственному пункту.
  useEffect(() => {
    if (onPage !== "payment") return;
    dispatch(setCardid(0));
    dispatch(setShouldSaveCard(false));
    if (onClickFunc) onClickFunc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onPage]);

  const handleSelectCard = (e: any) => {
    const target = e.target.closest("[data-type]");
    if (target) {
      target.style.boxShadow = "2px 2px 15px rgba(140, 179, 70, 1)";
    }
    dispatch(setCardid(0));
    dispatch(setShouldSaveCard(false));
    if (onClickFunc) onClickFunc();
  };

  if (onPage !== "payment") {
    return (
      <div className={Styles.item}>
        <p className={Styles.subTitile__otherMethods}>
          Привязка карт временно недоступна. Оплата проходит вводом карты на
          защищённой странице банка.
        </p>
      </div>
    );
  }

  return (
    <div className={Styles.item}>
      <div
        className={Styles.otherMethodsItem}
        data-type="cardItem"
        onClick={handleSelectCard}
      >
        <img src={cardIcon} alt="card icon" />
        <div>Оплатить картой</div>
      </div>
    </div>
  );
};
